import { useState, useEffect } from "react";
import youtube from "../api/youtube";

const useVideos = (defaultSearchTerm) => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    search(defaultSearchTerm);
  }, [defaultSearchTerm]);

  // const search = () => {};

  const search = async (term) => {
    setLoading(true);
    const response = await youtube.get("/search", {
      params: {
        q: term,
      },
    });

    setVideos(response.data.items);
  };

  return [videos, loading, setLoading, search];
};

export default useVideos;
